module.exports = __webpack_public_path__ + "media/images/emblems/Losone-coat_of_arms-f332a2a7deceaa1311dd7b71951c4692.svg";